var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/// <reference path="../../../typings/tsd.d.ts" /> 
var warsApp;
(function (warsApp) {
    var models;
    (function (models) {
        var Condition = /** @class */ (function (_super) {
            __extends(Condition, _super);
            function Condition() {
                return _super.call(this) || this;
                //this.expressionParts = [];
            }
            Condition.prototype.getText = function (processConfiguration) {
                if (this.isManuallyEdited)
                    return this.javascript;
                //if (!this.expressionParts) {
                //    this.reverseJavascript(processConfiguration);
                //}
            };
            //private getExpressionText(expression:BooleanExpression):string {
            //   if (expression.isFieldExpression) {
            //   }
            //}
            Condition.prototype.generateJavascript = function () {
                var jStr = 'if(';
                //TODO: Uncomment and fix
                //for (var i = 0; i < this.expressionParts.length; i++) {
                //    if (i !== 0) {
                //        if (this.expressionParts[i].logicalOperator == LogicalOperator.And) {
                //            jStr += " && ";
                //        }
                //        else if (this.expressionParts[i].logicalOperator == LogicalOperator.Or) {
                //            jStr += " || ";
                //        } else {
                //            jStr += " && ";
                //        }
                //    }
                //    jStr += "process['" + this.expressionParts[i].fieldName + "']";
                //    if (this.expressionParts[i].comparsionOperator == ComparisonOperator.Equals) {
                //        jStr += " == ";
                //    }
                //    else if (this.expressionParts[i].comparsionOperator == ComparisonOperator.NotEquals) {
                //        jStr += " != ";
                //    }
                //    else if (this.expressionParts[i].comparsionOperator == ComparisonOperator.GreaterThan) {
                //        jStr += " > ";
                //    }
                //    else if (this.expressionParts[i].comparsionOperator == ComparisonOperator.LessThan) {
                //        jStr += " < ";
                //    }
                //    else if (this.expressionParts[i].comparsionOperator == ComparisonOperator.GreaterThanOrEqual) {
                //        jStr += " >= ";
                //    }
                //    else if (this.expressionParts[i].comparsionOperator == ComparisonOperator.LessThanOrEqual) {
                //        jStr += " <= ";
                //    } else {
                //        jStr += " == ";
                //    }
                //    if (this.expressionParts[i].isFieldExpression) {
                //        jStr += "process['" + this.expressionParts[i].valueFieldName + "']";
                //    } else {
                //        var value = this.expressionParts[i].value;
                //        if (value == 'true' || value == 'false') {
                //            jStr += value;
                //        } else {
                //            jStr += "'" + this.expressionParts[i].value + "'";
                //        }
                //    }
                //}
                jStr += "){\n \treturn true;\n}\nreturn false;";
                this.javascript = jStr;
            };
            Condition.prototype.reverseJavascript = function (processConfiguration) {
                console.info("reverse");
                if (this == null || this.javascript == null)
                    return;
                // var parts = new Array<warsApp.models.BooleanExpression>();
                //var startIndex = this.javascript.indexOf("(");
                //var lastStart = this.javascript.lastIndexOf("(");
                //if (startIndex != lastStart) {
                //    //this.onlyShowAdvanced = true;
                //    return;
                //}
                //var endIndex = this.javascript.indexOf(")");
                //var conditionStr = this.javascript.substring(startIndex + 1, endIndex);
                //var andConditions = conditionStr.split(" && ");
                //var orConditions = conditionStr.split(" || ");
                //var firstAndIndex = conditionStr.indexOf(" && ");
                //var firstOrIndex = conditionStr.indexOf(" || ");
                //if (firstAndIndex == -1 && firstOrIndex == -1) {
                //    this.setParts(andConditions, true, true, parts, processConfiguration);
                //} else {
                //    if (firstAndIndex == -1) {
                //        this.setParts(orConditions, true, false, parts, processConfiguration);
                //    } else if (firstOrIndex == -1) {
                //        this.setParts(andConditions, true, true, parts, processConfiguration);
                //    } else {
                //        var isFirstAnd = firstAndIndex < firstOrIndex;
                //        this.setParts(andConditions, isFirstAnd, true, parts, processConfiguration);
                //        this.setParts(orConditions, !isFirstAnd, false, parts, processConfiguration);
                //    }
                //}
                //this.expressionParts = parts;
            };
            Condition.prototype.setParts = function (conditions, isFirst, isAnd, parts, processConfiguration) {
                for (var i = 0; i < conditions.length; i++) {
                    var partCondition = conditions[i].split(" ");
                    if (partCondition.length != 3) {
                        //this.onlyShowAdvanced = true;
                        return;
                    }
                    //TODO: Uncomment and fix
                    //var newPart = new warsApp.models.BooleanExpression();
                    //if (!isFirst || i != 0) {
                    //    if (isAnd) {
                    //        newPart.logicalOperator = LogicalOperator.And;
                    //    } else {
                    //        newPart.logicalOperator = LogicalOperator.Or;
                    //    }
                    //}
                    //newPart.setComparsionOperator(partCondition[1]);
                    //if (partCondition[0].indexOf("process['") == -1) {
                    //    //this.onlyShowAdvanced = true;
                    //    return;
                    //} else {
                    //    newPart.fieldName = partCondition[0].replace("process['", "").replace("']", "");
                    //    newPart.fieldText = this.getTextForUniqueName(newPart.fieldName, processConfiguration);
                    //}
                    //if (partCondition[2].indexOf("process['") == -1) {
                    //    newPart.value = partCondition[2].replace(/'/g, "");
                    //} else {
                    //    newPart.valueFieldName = partCondition[2].replace("process['", "").replace("']", "");
                    //    newPart.valueText = this.getTextForUniqueName(newPart.valueFieldName, processConfiguration);
                    //    newPart.isFieldExpression = true;
                    //}
                    //parts.push(newPart);
                }
            };
            Condition.prototype.getTextForUniqueName = function (name, form) {
                var fields = Wars.Domain.Model.ProcessConfigurationUtilities.GetFields(form);
                for (var i = 0; i < fields.length; i++) {
                    if (fields[i].schemaProperty.uniqueIdentifier == name) {
                        return fields[i].schemaProperty.name;
                    }
                }
                return '';
            };
            return Condition;
        }(BaseEntity));
        models.Condition = Condition;
    })(models = warsApp.models || (warsApp.models = {}));
})(warsApp || (warsApp = {}));
